import * as Yup from 'yup'
import {isLink} from './editChecks'

// const phoneRegExp = /^$|^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/
// eslint-disable-next-line no-useless-escape
const phoneRegExp = /(^$|[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6})$/im

export const validateContractName = (value) => {
    let error;
    if (!value) {
        error = 'Contract Name is required';
    }
    if(value&&value.length > 150) {
        error = 'Maximum of 150 characters';
    }
    return error;
}

export const validateContractURL = (value) => {
    let error;
    if (!value) {
        error = 'Contract URL is required';
    }
    if (value&&!isLink(value)) {
        error = 'Invalid URL. It has to be https or http format.';
    }
    return error;
}

export const AccountTabSchema = Yup.object().shape({
    existingContactInternal: Yup.boolean(),
    existingContactExternal: Yup.boolean(),
    accountId: Yup.string()
        .nullable()
        .max(16, 'Maximum of 16 characters'),
    accountPhoneNumber: Yup.string()
        .nullable()
        .matches(phoneRegExp, 'Invalid Phone Number'),
    accountEmailAddress: Yup.string()
        .nullable()
        .matches(/.+@.+\..+/, 'Invalid Email Address'),
    contactName: Yup.string()
        .nullable()
        .when("existingContactExternal", {
            is: false,
            then: Yup.string().max(100, 'Maximum of 100 characters')
        }),
    contactJobTitle: Yup.string()
        .nullable(),
    contactPhoneNumber: Yup.string()
        .nullable()
        .matches(phoneRegExp, 'Invalid Phone Number'),
    contactEmailAddress: Yup.string()
        .nullable()
        .matches(/.+@.+\..+/, 'Invalid Email Address'),
    beeCleanContactName: Yup.string()
        .nullable()
        .when("existingContactInternal", {
            is: false,
            then: Yup.string().max(100, 'Maximum of 100 characters')
        }),
    beeCleanJobTitle: Yup.string()
        .nullable(),
    beeCleanPhoneNumber: Yup.string()
        .nullable()
        .matches(phoneRegExp, 'Invalid Phone Number'),
    beeCleanEmailAddress: Yup.string()
        .nullable()
        .matches(/.+@.+\..+/, 'Invalid Email Address'),
});

export const tabListSchema = Yup.object().shape({
  tabList: Yup.array()
    .of(
      Yup.object().shape({
        custom_name: Yup.string()
          .max(10, 'Tab name is max. 10 characters.')
          .required('Tab name is required.')
      })
    )
})
